// extracted by mini-css-extract-plugin
export default {"timer":"GEPsl","rank":"i8qCV"};